var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pentagon",style:(_vm.baseStyles)},_vm._l((5),function(i){return _c('div',{key:i,staticClass:"pentagon__area"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }